import styled from 'styled-components';

export const ButtonedDropdownGroup = styled.div`
  display: inline-flex;
  align-items: stretch;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  background: ${({ theme }) => theme.button.primaryBackgroundColor};
  border: 1px solid ${({ theme }) => theme.button.borderColorPrimary};
  color: ${({ theme }) => theme.button.primaryTextColor};
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 0 8px;
  height: 24px;
  font-size: 11px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  line-height: 13px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  white-space: nowrap;
`;

export const Divider = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${({ theme }) => theme.button.borderColorPrimary};
  opacity: 0.6;
`;

export const ChevronTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
    path {
      fill: currentColor;
    }
  }
`;
